import { Store } from 'redux';
import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { RootState } from './redux/reducers/rootReducer';

export const setupLanguageInterceptor = (axiosInstance: AxiosInstance, store: Store<RootState>): number => {
  const requestInterceptorId = axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
      try {
        
        const state = store.getState();
        const currentLanguage = state?.currentLanguage;
        const currentCountry = state?.currentCountry;

        if (
          currentLanguage &&
          currentCountry &&
          typeof currentLanguage === 'string' &&
          typeof currentCountry === 'string' &&
          !config.headers?.['Accept-Language']
        ) {
          // Combine language + country: 'en' + 'US' = 'en-US'
          const locale = `${currentLanguage}-${currentCountry}`;
          // eslint-disable-next-line no-param-reassign
          config.headers['Accept-Language'] = locale;
        }

        return config;
      } catch (error) {
        console.error('Error in language interceptor:', error);
        return config;
      }
    },
    (error: unknown) => {
      console.error('Request interceptor error:', error);
      return Promise.reject(error);
    }
  );

  return requestInterceptorId;
};
